import React, { useState } from 'react';

export type MessageType = 'success' | 'info' | 'warning' | 'error';
interface MessageContextState {
  message?: string;
  messageType?: MessageType;
  // eslint-disable-next-line no-unused-vars
  setMessage: (message: string, messageType: MessageType) => void;
  // eslint-disable-next-line no-unused-vars
  setError: (message: string) => void;
  // eslint-disable-next-line no-unused-vars
  setWarning: (message: string) => void;
  // eslint-disable-next-line no-unused-vars
  setSuccess: (message: string) => void;
  // eslint-disable-next-line no-unused-vars
  setInfo: (message: string) => void;
  clearMessage: () => void;
}

const MessageContext = React.createContext<MessageContextState>(null as any);

const MessageContextProvider: React.FC<React.PropsWithChildren<{
  children: React.ReactNode;
}>> = (props) => {
  const { children } = props;
  const [message, setMessage] = useState<
    | {
        message: string;
        messageType: MessageType;
      }
    | undefined
  >();

  const _setMessage = (msg: string, messageType: MessageType) => {
    setMessage({
      message: msg,
      messageType,
    });
  };

  const _clearMessage = () => {
    setMessage(undefined);
  };

  return (
    <MessageContext.Provider
      value={{
        clearMessage: _clearMessage,
        setMessage: _setMessage,
        setError: (v) => _setMessage(v, 'error'),
        setInfo: (v) => _setMessage(v, 'info'),
        setWarning: (v) => _setMessage(v, 'warning'),
        setSuccess: (v) => _setMessage(v, 'success'),
        message: message?.message,
        messageType: message?.messageType,
      }}
    >
      {children}
    </MessageContext.Provider>
  );
};

export default MessageContext;
export const Provider = MessageContextProvider;
export const { Consumer } = MessageContext;
